/* PurryPurry signup popup (2026-10-23). Markup: sections/pp-signup-popup.liquid.
   - Auto-opens once per browser session after N seconds (or on desktop exit intent),
     never on cart/account/checkout pages, and waits while another overlay
     (customizer, size guide, lightbox, menu) is open.
   - Closing without signing up snoozes auto-open for N days and shows a small
     "GET 15% OFF" teaser bottom-left (hidden while other overlays are open).
   - Submits Shopify's customer form with fetch. If Shopify asks for a bot check
     (/challenge), falls back to a normal form submit; when the page comes back
     with ?customer_posted=true the success step is shown.
   - Debug: add ?pp_popup=1 to any URL to open it right away. */
(function () {
  'use strict';
  var root = document.getElementById('PPSignup');
  if (!root || root.dataset.ppInit) return;
  root.dataset.ppInit = '1';

  var teaser = document.getElementById('PPSignupTeaser');
  var form = document.getElementById('PPSignupForm');
  var email = document.getElementById('PPSignupEmail');
  var errEl = root.querySelector('.pp-su__error');
  var stepForm = root.querySelector('.pp-su__step--form');
  var stepDone = root.querySelector('.pp-su__step--done');
  var submitBtn = form ? form.querySelector('[type="submit"]') : null;
  var KEY_DONE = 'ppSignupDone', KEY_SNOOZE = 'ppSignupSnoozeUntil', KEY_TEASER_OFF = 'ppSignupTeaserOff', KEY_SHOWN = 'ppSignupShown';
  var delay = Math.max(3, parseInt(root.dataset.delay, 10) || 8) * 1000;
  var snoozeDays = Math.max(1, parseInt(root.dataset.snoozeDays, 10) || 7);
  var lastFocus = null;
  var isOpen = false;

  function ls(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function ss(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  var params = new URLSearchParams(window.location.search);
  var forceOpen = params.get('pp_popup') === '1';
  var postedBack = params.get('customer_posted') === 'true' || !!root.querySelector('[data-pp-su-posted]');
  var path = window.location.pathname;
  var blockedPage = /^\/(cart|account|checkout|checkouts|challenge|password|policies|orders|tools)(\/|$)/.test(path);
  var subscribed = root.dataset.subscribed === 'true' || ls(KEY_DONE) === '1';

  /* Another overlay open? (customizer, collar/pair step, size guide, lightbox, menu, search, picker) */
  var OVERLAYS = '.cpb-modal-overlay, .ppv2-lightbox, .ppv2-sg, .pp-picker, .pp-picker-overlay, [class*="picker-modal"], .menu-drawer-container[open], details[open] > .search-modal, cart-drawer.active';
  function otherOverlayOpen() {
    var els = document.querySelectorAll(OVERLAYS);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.hidden) continue;
      var cs = window.getComputedStyle(el);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && el.getClientRects().length) return true;
    }
    return false;
  }

  function showStep(done) {
    stepForm.hidden = !!done;
    stepDone.hidden = !done;
  }

  function trapFocus(e) {
    if (!isOpen || e.key !== 'Tab') return;
    var f = root.querySelectorAll('button:not([hidden]), a[href], input:not([type="hidden"])');
    var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
    if (!vis.length) return;
    var first = vis[0], last = vis[vis.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(done) {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    showStep(done);
    root.hidden = false;
    document.documentElement.classList.add('pp-su-lock');
    if (teaser) teaser.hidden = true;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    ss(KEY_SHOWN, '1');
    // load the success-step photo now so it is ready right after signup
    Array.prototype.forEach.call(root.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; });
    setTimeout(function () {
      var target = done ? root.querySelector('[data-pp-su-copy]') : (window.matchMedia('(min-width: 750px)').matches ? email : (function () { var d = root.querySelector('.pp-su__dialog'); if (d && !d.hasAttribute('tabindex')) d.setAttribute('tabindex', '-1'); return d; })());
      if (target) try { target.focus({ preventScroll: true }); } catch (e) {}
    }, 260);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('pp-su-lock');
    setTimeout(function () { root.hidden = true; }, 220);
    if (ls(KEY_DONE) !== '1') {
      ls(KEY_SNOOZE, String(Date.now() + snoozeDays * 864e5));
      showTeaser();
    }
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  function showTeaser() {
    if (!teaser || ls(KEY_DONE) === '1' || ls(KEY_TEASER_OFF) === '1' || blockedPage) return;
    teaser.hidden = false;
  }

  /* Hide the teaser while another overlay is open so it never covers their buttons */
  function watchOverlays() {
    if (!teaser) return;
    var tick = function () {
      if (!teaser.hidden) teaser.classList.toggle('is-suppressed', otherOverlayOpen() || document.documentElement.classList.contains('cpb-kb-open'));
    };
    setInterval(tick, 700);
  }

  function markDone() {
    ls(KEY_DONE, '1');
    ls(KEY_SNOOZE, null);
    if (teaser) teaser.hidden = true;
    try { window.dataLayer && window.dataLayer.push({ event: 'pp_signup_popup_submit' }); } catch (e) {}
  }

  function setError(msg) {
    if (!errEl) return;
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
    if (email) email.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  if (form) {
    form.addEventListener('submit', function (e) {
      if (form.dataset.native === '1') return; // fallback path: let the browser post normally
      e.preventDefault();
      var v = (email.value || '').trim();
      email.value = v;
      if (!validEmail(v)) { setError('Please enter a valid email address.'); email.focus(); return; }
      setError('');
      submitBtn.disabled = true;
      var label = submitBtn.textContent;
      submitBtn.textContent = 'ONE SEC…';
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (res) {
          var url = res.url || '';
          if (/\/challenge/.test(url)) { throw { challenge: true }; }
          return res.text().then(function (html) { return { res: res, url: url, html: html }; });
        })
        .then(function (r) {
          if (!/customer_posted=true/.test(r.url)) {
            var doc = new DOMParser().parseFromString(r.html, 'text/html');
            var errs = doc.querySelector('#PPSignupForm .pp-su__srv-err');
            if (errs && errs.textContent.trim()) { throw { message: errs.textContent.trim() }; }
            if (!r.res.ok) { throw { message: 'Something went wrong. Please try again.' }; }
            // Shopify returned the page without a form error: treat as subscribed
          }
          markDone();
          showStep(true);
          var c = root.querySelector('[data-pp-su-copy]');
          if (c) try { c.focus({ preventScroll: true }); } catch (e) {}
        })
        .catch(function (err) {
          if (err && err.challenge) {
            // Shopify bot check: do a normal submit; we come back with ?customer_posted=true
            ss('ppSignupPendingNative', '1');
            form.dataset.native = '1';
            form.submit();
            return;
          }
          setError((err && err.message) || 'Something went wrong. Please try again.');
        })
        .then(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = label;
        });
    });
    email.addEventListener('input', function () { if (errEl && !errEl.hidden) setError(''); });
  }

  /* Copy code */
  var copyBtn = root.querySelector('[data-pp-su-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var code = root.dataset.code || '';
      var note = copyBtn.querySelector('.pp-su__copied');
      var done = function () {
        if (!note) return;
        note.textContent = 'Copied!';
        note.classList.add('is-on');
        setTimeout(function () { note.classList.remove('is-on'); }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(code); done(); });
      } else { fallbackCopy(code); done(); }
    });
  }
  function fallbackCopy(text) {
    var t = document.createElement('textarea');
    t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
    document.body.appendChild(t); t.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(t);
  }

  /* Close / open handlers */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-pp-su-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') close();
    else trapFocus(e);
  });
  if (teaser) {
    teaser.addEventListener('click', function (e) {
      if (e.target.closest('[data-pp-su-teaser-off]')) {
        ls(KEY_TEASER_OFF, '1');
        teaser.hidden = true;
        return;
      }
      if (e.target.closest('[data-pp-su-open]')) open(false);
    });
  }
  var cta = root.querySelector('.pp-su__cta--link');
  if (cta) cta.addEventListener('click', function () { isOpen = false; document.documentElement.classList.remove('pp-su-lock'); });

  /* Theme editor: open when the section is selected */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.contains(root)) open(false);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.contains(root)) close();
  });

  /* Decide what to do on this page view */
  if (postedBack && (ss('ppSignupPendingNative') === '1' || !!root.querySelector('[data-pp-su-posted]'))) {
    try { window.sessionStorage.removeItem('ppSignupPendingNative'); } catch (e) {}
    markDone();
    open(true);
    return;
  }
  var srvErr = root.querySelector('[data-pp-su-srv-err]');
  if (srvErr && srvErr.textContent.trim()) { open(false); setError(srvErr.textContent.trim()); return; }
  if (forceOpen) { open(false); return; }
  watchOverlays();
  if (subscribed || blockedPage || window.Shopify && window.Shopify.designMode) return;

  var snoozeUntil = parseInt(ls(KEY_SNOOZE) || '0', 10);
  if (snoozeUntil > Date.now() || ss(KEY_SHOWN) === '1') { if (snoozeUntil > Date.now()) showTeaser(); return; }
  if (snoozeUntil) ls(KEY_SNOOZE, null);

  var fired = false;
  function tryOpen() {
    if (fired || isOpen) return;
    if (otherOverlayOpen() || document.documentElement.classList.contains('cpb-kb-open')) {
      setTimeout(tryOpen, 2000); // wait until the customer closes the other overlay
      return;
    }
    fired = true;
    open(false);
  }
  setTimeout(tryOpen, delay);
  // Desktop exit intent (mouse leaves through the top), after 3s on the page
  if (window.matchMedia('(min-width: 750px) and (hover: hover)').matches) {
    setTimeout(function () {
      document.addEventListener('mouseout', function onOut(e) {
        if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); tryOpen(); }
      });
    }, 3000);
  }
})();
